import React from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import AuthHeader from '../auth/AuthHeader';
import logo from '../../img/logo.png';

const useStyles = makeStyles((theme) => ({
    header: {
        padding: '1rem 5rem',
        height: '8rem',
        display: 'flex',
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'space-between',
        [theme.breakpoints.down('sm')]: {
            padding: '0.5rem',
        },
    },
    logo: {
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
        color: 'inherit',
        '& img': {
            height: '5rem',
        },
    },
    title: {
        fontSize: '2.4rem',
        margin: 0,
        marginLeft: '1rem',
        fontFamily: "'Kosugi Maru', 'Noto Sans JP', sans-serif !important",
        [theme.breakpoints.down('sm')]: {
            whiteSpace: 'pre-wrap',
            fontSize: '1.7rem',
            fontWeight: 700,
        },
    },
}));

export default function Header() {
    const classes = useStyles();

    return (
        <header className={classes.header}>
            <Link to="/" className={classes.logo}>
                <img src={logo} alt="Logo" />
                <Typography variant="h1" className={classes.title}>
                    ニュージーワークス
                </Typography>
            </Link>
            <AuthHeader />
        </header>
    );
}
